module.exports = __webpack_public_path__ + "img/folder-symlink-fill.f07a01ef.svg";